module.exports = __webpack_public_path__ + "static/media/bnr_sora831dab8d6ade7534d92136d5106542df.webp";